import React from "react";
import { useNavigate } from "react-router-dom";
import ModalNew from "../../../../../components/ui/popup/Modal";

const CpaAcceptedFilingModal = ({ isOpen, onClose, filingUuid }) => {
  const navigate = useNavigate();
  if (!isOpen) return null;

  return (
    <ModalNew style={{ maxWidth: "450px" }}>
      <div style={{ padding: "24px", textAlign: "center" }}>
        <p
          style={{
            fontSize: "16px",
            color: "#1A2127",
            marginBottom: "24px",
            lineHeight: "1.5",
          }}
        >
          Consider sending a message to the taxpayer to let them know you've
          started working on their filing.
        </p>
        <div style={{ display: "flex", gap: "12px", justifyContent: "center" }}>
          <button
            type="button"
            className="cta-button secondary"
            onClick={onClose}
          >
            Close
          </button>
          <button
            type="button"
            className="cta-button primary"
            onClick={() => {
              onClose();
              navigate(`/tax-filing/filing/${filingUuid}/messages`);
            }}
          >
            Send Message
          </button>
        </div>
      </div>
    </ModalNew>
  );
};

export default CpaAcceptedFilingModal;
